import styled from "styled-components";
import Status from "../types/enum/Status";
import Button from "./Button";
import FlexBox, { FlexGrow } from "./FlexBox";
import { ClickableIcon } from "./Icon";
import Modal from "./Modal";
import { Icon } from "@mui/material";

type CourseDropModalProps = {
  isOpen?: boolean;
  setOpen: (x: boolean) => void;
  title: string;
  description: string;
};
const Title = styled.div`
  display: flex;
  align-items: center;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
`;
const Flex = styled(FlexGrow)`
  padding: 0px 24px;
  width: 318px;
  background: #191b34;
  border: 1px solid #3c406c;
  border-radius: 4px;
  margin: 6px 0 0 0;
`;
const Desc = styled.p`
  color: #e6e6e6;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  padding: 16px 0;
  display: flex;
  align-items: center;
  margin: 0px 10px;
`;

const WarningModal = ({
  isOpen,
  setOpen,
  title,
  description,
}: CourseDropModalProps): JSX.Element => {
  return (
    <>
      <Modal
        isOpen={isOpen || false}
        setOpen={setOpen}
        customStyle={{
          overlay: { zIndex: "99900" },
          content: {
            maxWidth: "500px",
            padding: 0,
            background: "#090d20",
            border: "1px solid #2D416C",
            boxShadow: "0px 4px 16px rgba(0,0,0)",
            borderRadius: "8px",
            marginTop: 100,
          },
        }}
      >
        <FlexBox style={{ height: "64px", margin: "10px 20px 10px 20px" }}>
          <FlexGrow>
            <Title>{title}</Title>
          </FlexGrow>
          <ClickableIcon name="times" onClick={() => setOpen(false)} />
        </FlexBox>
        <FlexBox style={{ margin: "0px 20px 0px 20px" }}>
          <Flex>
            <Desc>
              <Icon
                sx={{
                  color: "#f5a623",
                  fontSize: "32px",
                  marginRight: "12px",
                  flexShrink: 0,
                }}
              >
                warning_amber_rounded
              </Icon>
              <span>{description}</span>
            </Desc>
          </Flex>
        </FlexBox>
        <FlexBox justify="end" style={{ padding: 20 }}>
          <FlexGrow style={{ flexGrow: "0" }}>
            <Button
              style={{
                width: "151px",
                height: "48px",
                padding: "13px 12px",
              }}
              status={Status.button}
              onClick={() => {
                setOpen(false);
              }}
            >
              Ok
            </Button>
          </FlexGrow>
        </FlexBox>
      </Modal>
    </>
  );
};

export default WarningModal;
